import { COLOR_BASE_GREY_5, COLOR_BASE_GREY_70 } from '@audi/audi-ui-design-tokens';
import styled from 'styled-components';
import { customBreakPoint } from '~/styles/break-points';

interface StyledResultTileProps {
	$isFeaturesVisible?: boolean;
	$height?: number;
}

export const StyledResultTile = styled.a<StyledResultTileProps>`
	border: 0.5px solid ${COLOR_BASE_GREY_70};
	display: flex;
	flex-direction: column;
	padding-bottom: 24px;
	transition: all 0.3s ease-out;

	&:hover {
		box-shadow:
			0 10px 15px -3px rgb(0 0 0 / 0.1),
			0 4px 6px -4px rgb(0 0 0 / 0.1);
	}

	.tile--top {
		padding: 24px;
		display: flex;
		flex-direction: column;
		${(props) => props.$isFeaturesVisible && `background-color: ${COLOR_BASE_GREY_5};`}

		ol {
			margin-top: 1rem;
			list-style: decimal;
			margin-left: 1rem;

			li {
				padding: 0.3rem 0;
			}
		}

		& .tile--top--header {
			${(props) => !props.$isFeaturesVisible && `margin-bottom: 1rem;`}

			.tile--match-container {
				display: flex;
				gap: 0.3rem;
				align-items: end;
			}
			button {
				z-index: 1;
			}
		}
	}

	.tile--bottom {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		padding: 12px 24px 0 24px;

		.divider {
			margin: 16px 0;
		}

		.car-name {
			margin-bottom: 16px;
		}

		.city {
			margin-bottom: 16px;
		}

		.cta {
			margin-top: auto;
		}
	}

	${customBreakPoint(500, 'max-width: 320px;')}
`;
